import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChatState {
  isConnected: boolean;
  isConnecting: boolean;
  unreadCount: number;
  error: string | null;
}

const initialState: ChatState = {
  isConnected: false,
  isConnecting: false,
  unreadCount: 0,
  error: null,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setChatConnecting: (state) => {
      state.isConnecting = true;
      state.error = null;
    },
    setChatConnected: (state) => {
      state.isConnected = true;
      state.isConnecting = false;
      state.error = null;
    },
    setChatDisconnected: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.error = null;
    },
    setChatError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isConnecting = false;
    },
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
  },
});

export const {
  setChatConnecting,
  setChatConnected,
  setChatDisconnected,
  setChatError,
  setUnreadCount,
} = chatSlice.actions;

export default chatSlice.reducer;
